
var p31Campaigns = {
  getActive: function(type) {
    if (!p31Campaigns.hasOwnProperty(type))
      return;
    let curDate = new Date();
    let cartAmount = upManager.lineItemTotal;
    for(let i = 0; i < p31Campaigns[type].length; i++)
    {
      let startDate = p31Campaigns[type][i].start;
      let endDate = p31Campaigns[type][i].end;
      let threshold = p31Campaigns[type][i].threshold ?? 0;
      if (curDate.getTime() >= startDate.getTime() && curDate.getTime() < endDate.getTime() && cartAmount >= threshold)
      {
        console.log("Init campaign")
        p31Campaigns[type][i].init();
		break;
      }
    }
  },
  donations: [],
  products: []
};

//2023 11/20-11/27
p31Campaigns.products.push({
  start: new Date(2023, 10, 20),
  end: new Date(2023, 10, 28),
  init: function() {
    p31products.headerMsg = `
      <p>For reminders that God is carrying you through each and every moment of the year ...</p>
      <p>Our new <strong>"Peace When You Are Anxious and Overwhelmed"</strong> 2024 Calendar is here.</p>
    `;
    p31products.disclaimer = null;
    p31products.products.push({
      "id": 6841736888404,
      "vid": 40112883728468,
      "price": null,
      "image": {
        "url": "https://cdn.shopify.com/s/files/1/0219/1772/files/calendar_2024_desktop_popup.jpg?v=1700489718",
        "height": 0,
        "width": 0,
        "alt": "Product Image"
      },
      "imageMobile": {
        "url": "https://cdn.shopify.com/s/files/1/0219/1772/files/calendar_2024_mobile_popup.jpg?v=1700489729",
        "height": 0,
        "width": 0,
        "alt": "Product Image"
      }
    });
  }
});

//2023 7/28-7/31
p31Campaigns.products.push({
  start: new Date(2023, 6, 28),
  end: new Date(2023, 7, 1),
  threshold: 3000,
  init: function() {
    p31products.headerMsg = "<p style='font-size:18px;text-align:center;'>Yay! Your cart qualifies for 50% off <em>I'll Start Again Monday.</em></p>";
    p31products.disclaimer = null;
    p31products.products.push({
      "id": 6674631557204,
      "vid": 39540081295444,
      "price": null,
      "image": {
        "url": "https://cdn.shopify.com/s/files/1/0219/1772/files/Terkeurst_ISAM_2021.jpg?v=1690306901",
        "height": 0,
        "width": 0,
        "alt": "Product Image"
      },
      "imageMobile": {
        "url": "https://cdn.shopify.com/s/files/1/0219/1772/files/Terkeurst_ISAM_2021.jpg?v=1690306901",
        "height": 0,
        "width": 0,
        "alt": "Product Image"
      }
    });
  }
});

//2022 12/14 - 12/31
p31Campaigns.donations.push({
  start: new Date(2022, 11, 14),
  end: new Date(2023, 0, 1),
  init: function() {
    document.getElementById("modal-content").style.maxWidth = "1000px";
    p31cart.headerMsg = `
      <p>When we need guidance to know what to do next but we just aren't sure who to listen to ...</p>
      <p>Proverbs 31 Ministries wants to be one of the places where you can turn when you're most depleted, to help you soak in wisdom and Truth.</p>
      <p>Will you help us continue to provide free biblical resources to you and other women like you by donating today?</p>
    `;
    p31cart.listDonations.shift(); //remove 10
  	p31cart.listDonations.unshift({"id": 4766897242196,"vid": 39409953210452}); //12
  	p31cart.listDonations.push({"id":4776995225684,"vid":32891111571540}); //75
  }
});

//2022 12/12 - 12/13
p31Campaigns.donations.push({
  start: new Date(2022, 11, 12),
  end: new Date(2022, 11, 14),
  init: function() {
    document.getElementById("modal-content").style.maxWidth = "1000px";
    p31cart.headerMsg = `
      <p>When we need wisdom to know what to do next but we just aren't sure who to listen to ...</p>
      <p>Proverbs 31 Ministries wants to be one of the places where you can turn when you're most depleted, to help you soak in wisdom and Truth.</p>
      <p>Will you help us continue to provide free biblical resources to you and other women like you by donating today?</p>
      <p><em>From December 12-13, all donors of $100 or more will get a free digital copy of our</em> God Has Not Forgotten <em>Experience Guide!</em></p>
    `;
    p31cart.listDonations.shift(); //remove 10
  	p31cart.listDonations.unshift({"id": 4766897242196,"vid": 39409953210452}); //12
  	p31cart.listDonations.push({"id":4776995225684,"vid":32891111571540}); //75
  }
});

//2022 11/28 - 12/9
p31Campaigns.donations.push({
  start: new Date(2022, 10, 28),
  end: new Date(2022, 11, 10),
  init: function() {
    document.getElementById("modal-content").style.maxWidth = "1000px";
    p31cart.headerMsg = `
      <p>Our matching challenge is happening now! Give today and your gift will make twice the impact!</p>
    `;
    p31cart.listDonations.shift(); //remove 10
  	p31cart.listDonations.unshift({"id": 4766897242196,"vid": 39409953210452}); //12
  	p31cart.listDonations.push({"id":4776995225684,"vid":32891111571540}); //75
  }
});

//2022 11/21 - 11/28
p31Campaigns.products.push({
  start: new Date(2022, 10, 21),
  end: new Date(2022, 10, 29),
  init: function() {
    p31products.headerMsg = "<p style='font-size:18px;text-align:center;'>Get a FREE copy of <em>Seeing Jesus in the Old Testament</em> by Lysa TerKeurst<br />with any purchase through November 28.*</p>";
    p31products.disclaimer = "*Purchases must include a physical product; digital items are not included.<br />Discounts will be applied at checkout.";
    p31products.products.push({
      "id": 6639573794900,
      "vid": 39470618345556,
      "price": null,
      "image": {
        "url": "https://cdn.shopify.com/s/files/1/0566/8755/8837/files/2022_CyberWeek_Cart-PopUp_desktop.jpg?v=1667418600",
        "height": 0,
        "width": 0,
        "alt": "Free Product Image"
      },
      "imageMobile": {
        "url": "https://cdn.shopify.com/s/files/1/0566/8755/8837/files/2022_CyberWeek_Cart-PopUp_mobile.jpg?v=1667418600",
        "height": 0,
        "width": 0,
        "alt": "Free Product Image"
      }
    });
  }
});

//2022 11/16 - 11/27
p31Campaigns.donations.push({
  start: new Date(2022, 10, 16),
  end: new Date(2022, 10, 28),
  init: function() {
    document.getElementById("modal-content").style.maxWidth = "1000px";
    p31cart.headerMsg = `
      <p>When we need guidance to know what to do next but we just aren't sure who to listen to ...<br/><br/>
      Proverbs 31 Ministries wants to be one of the places where you can turn when you're most depleted, to help you soak in wisdom and Truth.<br/><br/>
      Will you help us continue to provide free biblical resources to you and other women like you by donating today?</p>
    `;
    p31cart.listDonations.shift(); //remove 10
  	p31cart.listDonations.unshift({"id": 4766897242196,"vid": 39409953210452}); //12
  	p31cart.listDonations.push({"id":4776995225684,"vid":32891111571540}); //75
  }
});

/*
//TEST TEMPLATE
p31Campaigns.donations.push({
  start: new Date(2022, 9, 20),
  end: new Date(2022, 10, 1),
  init: function() {
    document.getElementById("modal-content").style.maxWidth = "1000px";
    //document.getElementById("modal-header-msg").innerHTML = "<p>We know the feeling of desperately wanting to experience a breakthrough for yourself or someone you love.<br/><br>The prayers prayed. The tears cried. The time invested.<br/><br><strong>God's Word is the only investment that won't return empty.</strong><br/><br>That’s why at Proverbs 31 Ministries, we want to reach women with Truth that changes everything.<br/><br>Will you help us continue to provide free biblical resources to you and other women like you by donating today?</p>";
    p31cart.headerMsg = `
      <p>We know the feeling of desperately wanting to experience a breakthrough for yourself or someone you love.<br/><br/>
      The prayers prayed. The tears cried. The time invested.<br/><br/>
      <strong>God's Word is the only investment that won't return empty.</strong><br/><br/>
      That’s why at Proverbs 31 Ministries, we want to reach women with Truth that changes everything.<br/><br/>
      Will you help us continue to provide free biblical resources to you and other women like you by donating today?</p>
    `;
    p31cart.listDonations.shift(); //remove 10
  	p31cart.listDonations.unshift({"id": 4766897242196,"vid": 39409953210452}); //12
  	p31cart.listDonations.push({"id":4776995225684,"vid":32891111571540}); //75
  }
});
*/
//2022 05/20 - 05/31
p31Campaigns.donations.push({
  start: new Date(2022, 4, 20),
  end: new Date(2022, 5, 1),
  init: function() {
    document.getElementById("modal-content").style.maxWidth = "1000px";
    document.getElementById("modal-header-msg").innerHTML = "<p>We know the feeling of desperately wanting to experience a breakthrough for yourself or someone you love.<br/><br>The prayers prayed. The tears cried. The time invested.<br/><br><strong>God's Word is the only investment that won't return empty.</strong><br/><br>That’s why at Proverbs 31 Ministries, we want to reach women with Truth that changes everything.<br/><br>Will you help us continue to provide free biblical resources to you and other women like you by donating today?</p>";
    p31cart.listDonations.shift(); //remove 10
  	p31cart.listDonations.unshift({"id": 4766897242196,"vid": 39409953210452}); //12
  	p31cart.listDonations.push({"id":4776995225684,"vid":32891111571540}); //75
  }
});

//2022 05/17 - 05/20
p31Campaigns.donations.push({
  start: new Date(2022, 4, 17),
  end: new Date(2022, 4, 21),
  init: function() {
    document.getElementById("modal-content").style.maxWidth = "1000px";
    document.getElementById("modal-header-msg").innerHTML = "<p>Our matching challenge is happening now! Give today, and your gift will make twice the impact!</p>";
    p31cart.listDonations.shift(); //remove 10
  	p31cart.listDonations.unshift({"id": 4766897242196,"vid": 39409953210452}); //12
  	p31cart.listDonations.push({"id":4776995225684,"vid":32891111571540}); //75
  }
});